import { configureStore } from "@reduxjs/toolkit";

import auth, { AuthState } from "store/auth";
import config, { ConfigState } from "store/config";
import locale, { LocaleState } from "store/locale";
import role, { RoleState } from "store/role";
import permission, { PermissionState } from "store/permission";
import user, { UserState } from "store/user";
import folder, { FolderState } from "store/folder";
import file, { FileState } from "store/file";
import status, { StatusState } from "store/status";
import workflow, { WorkflowState } from "store/workflow";
import step, { StepState } from "store/step";
import form, { FormState } from "store/form";
import formBuilder, { FormBuilderState } from "./form-builder";
import page, { PageState } from "store/page";
import module, { ModuleState } from "store/module";
import layout, { LayoutState } from "store/layout";
import pageBuilder, { PageBuilderState } from "store/page-builder";
import groupUser, { GroupUserState } from "./group-user";


import cache, { CacheState } from "./cache";

export const store = configureStore({
  reducer: {
    auth,
    config,
    locale,
    role,
    permission,
    user,
    groupUser,
    folder,
    file,
    status,
    workflow,
    step,
    form,
    formBuilder,
    page,
    module,
    layout,
    pageBuilder,

    // 
    cache,
  },
});

export interface RootState {
  auth: AuthState;
  config: ConfigState;
  locale: LocaleState;
  role: RoleState;
  permission: PermissionState;
  user: UserState;
  groupUser: GroupUserState;
  folder: FolderState;
  file: FileState;
  status: StatusState;
  workflow: WorkflowState;
  step: StepState;
  form: FormState;
  formBuilder: FormBuilderState;
  page: PageState;
  module: ModuleState;
  layout: LayoutState;
  pageBuilder: PageBuilderState;

  // 
  cache: CacheState;
}
export type AppDispatch = typeof store.dispatch;

export default RootState;